import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import i18next from "i18next";
import Card from "components/Card/Card";
import defaultProfileImage from "assets/img/convention/collageTest.jpg";
import { subtitleLandingMedium } from "assets/jss/material-kit-pro-react";
import { subtitleLandingLight } from "assets/jss/material-kit-pro-react";

const useStyles = makeStyles(() => ({
  card: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    padding: "16px",
    boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
    borderRadius: "12px",
    backgroundColor: "white",
  },
  img: {
    width: "80px",
    height: "80px",
    objectFit: "cover",
    borderRadius: "8px",
    marginRight: "15px",
    flexShrink: 0,
  },
  textContent: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    color: "black",
    flex: 1,
  },
  title: {
    ...subtitleLandingMedium,
    fontWeight: "bold",
    textTransform: "uppercase",
    marginBottom: "5px",
    fontSize: "14px",
  },
  description: {
    ...subtitleLandingLight,
    fontSize: "13px",
  },
}));

export default function ActivityCardMobile({ activity }) {
  const classes = useStyles();
  const getCurrentLng = () =>
      i18next.language || window.localStorage.i18nextLng || "en";
    const selectedLanguage = getCurrentLng();
  const { description, img, title } = activity;

  return (
    <Card className={classes.card}>
      <img
        src={img || defaultProfileImage}
        alt={title}
        className={classes.img}
      />
      <div className={classes.textContent}>
        <div className={classes.title}>{title[selectedLanguage]}</div>
        <div className={classes.description}>{description[selectedLanguage]}</div>
      </div>
    </Card>
  );
}
